import { render, staticRenderFns } from "./BnRetrClientsDetail.vue?vue&type=template&id=342bbbda&"
import script from "./BnRetrClientsDetail.vue?vue&type=script&lang=js&"
export * from "./BnRetrClientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BnRetrClientsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports